export const GENERIC_SCANNER_DRIVER_NAME = "generic-scanner";
